import { logInfo } from "../utils/log";
import { waitForDOMStability } from "../utils/waitForDOMStability";
import { RuleAction } from "./RuleAction";
import { extractRelevantAttributes } from "./extractRelevantAttributes";
import { findFullMatch } from "./findFullMatch";
import { getErrorMessage } from "./getErrorMessage";
import { ActionReportItem } from "./sendActionsReport";
import { waitForElementByCssSelector } from "./waitForElementByCssSelector";

/**
 *
 * @param actions  all actions to be performed
 */
export const actionsInterpreter = async (
  actions: Array<RuleAction>
): Promise<Array<ActionReportItem>> => {
  const reportData: Array<ActionReportItem> = [];

  logInfo("Executing actions: ", actions);

  for (const action of actions) {
    const actionStartTime = new Date().valueOf();
    logInfo("Executing action: ", action);

    try {
      logInfo("Waiting for element: ", action.selector);
      await waitForElementByCssSelector(action.selector);
      logInfo("Waited for element: ", action.selector);
      const elementsToMatch = Array.from(
        document.querySelectorAll(action.selector)
      ) as HTMLElement[];
      logInfo("Elements to match: ", elementsToMatch);
      const fullMatch = findFullMatch(action, elementsToMatch);
      logInfo("Full match: ", fullMatch);

      if (fullMatch) {
        fullMatch.click();
        logInfo("Clicked full match: ", fullMatch);
        reportData.push({
          action,
          elementsFound: 1,
          elementClicked: extractRelevantAttributes(fullMatch),
          selector: action.selector,
          tagName: action.tagName || undefined,
          clicked: true,
          processingTime: new Date().valueOf() - actionStartTime,
          errors: [],
        });
      } else {
        reportData.push({
          action,
          elementsFound: 0,
          elementClicked: undefined,
          selector: action.selector,
          tagName: action.tagName || undefined,
          clicked: false,
          processingTime: new Date().valueOf() - actionStartTime,
          errors: [],
        });
      }
    } catch (error) {
      // report error
      reportData.push({
        action,
        elementsFound: 0,
        elementClicked: undefined,
        selector: action.selector,
        tagName: action.tagName || undefined,
        clicked: false,
        processingTime: new Date().valueOf() - actionStartTime,
        errors: [getErrorMessage(error)],
      });
    }
    await waitForDOMStability();
  }

  return reportData;
};
